export default "__VITE_ASSET__BGdcWGoU__"